<template lang="pug">
  .component-policy-button
    .dropdown-buttons
      router-link(:to="{name:'group', params:{id:item.id}}") Edit
      ActionButton(:action="remove", :confirm="true") Delete

</template>

<script>
  import PolicyReveal from '../../../../pages/backoffice/PolicyReveal'
  import ModalReveal from '../../foundation/ModalReveal'
  import ActionButton from '../ActionButton'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../maggieHelper'
  import GroupReveal from '../../../../pages/backoffice/GroupEdit'

  export default {
    name: 'GroupButtons',
    components: {GroupReveal, PolicyReveal, ActionButton, ModalReveal},
    data() {
      return {}
    },
    created() {


    },

    methods: {
      remove() {
        return KeplerBackofficeSdk.groups.select(this.item).remove(() => {
          MaggieHelper.notification('Policy', 'Policy deleted')
          this.$emit('itemUpdated')
        })
      }
    },

    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// GroupButtons.vue?38e626ac